<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title">내 정보 수정</p>
                <form id="user_form">
                    <div class="profile_input_box">
                        <div class="profile_preview">
                            <img :src="state.imgUrl" />
                        </div>
                        <label>
                            <input @change="uploadImg" id="file" type="file" placeholder="파일첨부" accept="image/*" />
                            <div :style="!state.isProfileImg ? 'display:block' : 'display:none'"
                                class="file_btn file_upload_btn"></div>
                        </label>
                        <div type="button" :style="state.isProfileImg ? 'display:block' : 'display:none'"
                            class="file_btn file_reset_btn" @click="basicImg"></div>
                    </div>
                    <div class="input_wrap">
                        <div class="input_box readonly_box">
                            <span class="ico"><img src="@/assets/user/form_ico1.png" /></span>
                            <input type="text" placeholder="이메일" :value="state.userInfo.id" readonly />
                        </div>
                        <div class="input_box readonly_box">
                            <span class="ico"><img src="@/assets/user/form_ico3.png" /></span>
                            <input type="text" placeholder="이름" :value="state.userInfo.name" readonly />
                        </div>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico4.png" /></span>
                            <div class="info_input_box">
                                <input type="tel" placeholder="전화번호" v-model="userInfo.phone"
                                    @change="userInfo.phone" />
                            </div>
                        </div>
                        <div class="input_box readonly_box">
                            <span class="ico"><img src="@/assets/user/form_ico4.png" /></span>
                            <div class="radio_wrap">
                                <label class="radio" for="gender1">
                                    <input type="radio" :checked="state.userInfo.gender === 0" disabled />
                                    <b></b>
                                    <span>남</span>
                                </label>
                                <label class="radio" for="gender2">
                                    <input type="radio" :checked="state.userInfo.gender === 1" disabled />
                                    <b></b>
                                    <span>여</span>
                                </label>
                            </div>
                        </div>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico3.png" /></span>
                            <input type="text" v-model="userInfo.height" placeholder="키" />cm
                        </div>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico3.png" /></span>
                            <input type="text" v-model="userInfo.weight" placeholder="몸무게" />kg
                        </div>
                        <div class="input_box readonly_box">
                            <span class="ico"><img src="@/assets/user/form_ico5.png" /></span>
                            <input type="text" v-model="userInfo.birth" placeholder="생년월일" readonly />
                        </div>
                        <div class="input_box">
                            <span class="ico"><img src="@/assets/user/form_ico6.png" /></span>
                            <input type="text" v-model="userInfo.dept" placeholder="소속" />
                        </div>
                    </div>
                    <div class="mini_submit_btn">
                        <button type="submit" id="submit_btn" @click="checkForm">
                            <img src="@/assets/common/write_ico.png" />수정완료
                        </button>
                        <button type="button" class="back_btn" @click="$router.back()">
                            <img src="@/assets/user/back_ico.png" />뒤로가기
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="modal.content" :yes="modal.confirm" :no="modal.cancel"
        @close="modalClose">
    </ModalComponent>
</template>

<script lang="ts" config>
import {
    userStore,
    reactive,
    res,
    watch,
    onMounted,
    globalStore,
    imgRender,
    router,
    apiService,
    ModalComponent,
    HeaderLayout,
    GnbLayout,
    dateFormat,
} from "@/BaseComponent";

export default {
    props: {},
    components: {
        ModalComponent,
        HeaderLayout,
        GnbLayout,
    },
    setup() {
        const user = userStore();
        const state = reactive({
            isNavOpen: true,
            userInfo: {} as any,
            imgUrl: "" as any,
            isProfileImg: false as boolean,
            popState01: false,
            isEditing: false,
            createDate: 0 as number,
            isModalOpen: false as boolean,
        });
        const userInfo = reactive({
            phone: "" as string,
            birth: "" as string,
            weight: "" as string,
            height: "" as string,
            dept: "" as string,
            profileImg: null as any,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        state.imgUrl = require("@/assets/basic_profile.png");
        const uploadImg = (e: any) => {
            const files = e.target.files;
            if (files.length > 0) {
                const file = files[0];
                if (file instanceof Blob) {
                    let url = URL.createObjectURL(file);
                    state.imgUrl = url;
                    imgRender(files, state.imgUrl);
                    userInfo.profileImg = file;
                    state.isProfileImg = !state.isProfileImg;
                }
            } else {
                userInfo.profileImg = null;
            }
        };

        onMounted(async () => {
            if (user.token) {
                const res = await apiService.member.getInfo();

                state.userInfo = res.data;
                if (state.userInfo.profileImg && state.userInfo.profileImg !== "") {
                    state.imgUrl = state.userInfo.profileImg;
                    state.isProfileImg = !state.isProfileImg;
                }
                userInfo.phone = state.userInfo.phone;
                userInfo.birth = dateFormat(state.userInfo.birth);
                userInfo.weight = state.userInfo.weight;
                userInfo.height = state.userInfo.height;
                userInfo.dept = state.userInfo.dept;
            }
        });
        const basicImg = () => {
            state.imgUrl = require(`@/assets/basic_profile.png`);
            userInfo.profileImg = null;
            state.isProfileImg = !state.isProfileImg;
        };

        const save = async () => {
            const param: FormData = new FormData();
            if (userInfo.profileImg != null) param.append("file", userInfo.profileImg);
            param.append("phone", userInfo.phone);
            param.append("weight", userInfo.weight);
            param.append("height", userInfo.height);
            param.append("dept", userInfo.dept);

            const response = await apiService.member.modify(param);
            if (response.returnCode === 0) {
                let res2: res = await apiService.member.getInfo();

                if (res2.returnCode === 0) {
                    user.setInfo(res2.data);
                    modal.content = "변경이 완료 되었습니다.";
                    state.isModalOpen = true;
                    modal.confirm = "확인";
                    modal.cancel = "";
                }
            } else {
                modal.content = response.description;
                state.isModalOpen = true;
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const checkForm = (e: any) => {
            e.preventDefault();
            if (userInfo.height && userInfo.weight && userInfo.phone !== "") {
                save();
            } else {
                modal.content = "수정 항목을 확인해주세요";
                state.isModalOpen = true;
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const modalClose = (result: any) => {
            state.isModalOpen = false;
            if (result === true) {
                router.push("/mypage");
            }
        };

        return {
            user,
            state,
            modal,
            userInfo,
            router,
            uploadImg,
            basicImg,
            save,
            checkForm,
            modalClose,
            dateFormat,
        };
    },
};
</script>
